import React from "react";
import { Backdrop, Popper, Typography } from "@material-ui/core";

type Props = {
  text: string;
  onClose: (e: React.SyntheticEvent<any>) => void;
  instancePrefix: string;
};

export function EmptyMenuRenderer(props: Props) {
  const anchor = document.getElementById(`${props.instancePrefix}-value`).parentElement
    .parentElement;

  const anchorWidth = anchor.getBoundingClientRect().width;

  return (
    <Popper
      open={true}
      id={props.instancePrefix}
      anchorEl={anchor}
      style={{
        zIndex: 9999
      }}
      placement="bottom-start"
    >
      <Backdrop open invisible onClick={props.onClose} />
      <div
        className="Select-menu-dropdown"
        style={{ minWidth: anchorWidth, padding: 16 }}
      >
        <Typography>{props.text}</Typography>
      </div>
    </Popper>
  );
}
